<template>
  <Modal v-show="dialogs.interests" v-model="dialogs.interests" class="modal__Filters modal__Interests">
    <div class="modal__FiltersInner">
      <h2>{{ $t('profile.interestsModalTitle') }}</h2>

      <div class="modal__FiltersList">
        <SelectField v-model="preferencesData.traveling_with" :options="travelOptions" :label="$t('forms.travel')" />

        <h3 v-text="$t('profile.preferredAccommodation')" />
        <div class="modal__FiltersGroupItems">
          <CheckboxField v-model="preferencesData.hotel">
            <Icon name="hotel" />
            <p>{{ $t('profile.hotel') }}</p>
          </CheckboxField>
          <CheckboxField v-model="preferencesData.mobile_homes">
            <p>{{ $t('profile.mobileHomes') }}</p>
          </CheckboxField>
          <CheckboxField v-model="preferencesData.campsite">
            <Icon name="campsite" />
            <p>{{ $t('profile.campsite') }}</p>
          </CheckboxField>
        </div>

        <h3 v-text="$t('profile.holidayType')" />
        <div class="modal__FiltersGroupItems">
          <CheckboxField v-model="preferencesData.family">
            <p>{{ $t('profile.family') }}</p>
          </CheckboxField>
          <CheckboxField v-model="preferencesData.sport">
            <p>{{ $t('profile.sport') }}</p>
          </CheckboxField>
          <CheckboxField v-model="preferencesData.wellness">
            <p>{{ $t('profile.wellness') }}</p>
          </CheckboxField>
          <CheckboxField v-model="preferencesData.gourmet">
            <p>{{ $t('profile.gourmet') }}</p>
          </CheckboxField>
          <CheckboxField v-model="preferencesData.romance">
            <p>{{ $t('profile.romance') }}</p>
          </CheckboxField>
          <CheckboxField v-model="preferencesData.excursions">
            <p>{{ $t('profile.excursions') }}</p>
          </CheckboxField>
        </div>

        <h3 v-text="$t('profile.petFriendlyFacilities')" />
        <div class="modal__FiltersGroupItems">
          <FieldGroup class="profile__FormRadioFields">
            <RadioField v-model="preferencesData.pet_friendly" :label="$t('yes')" :value="true" :round="true" />
            <RadioField v-model="preferencesData.pet_friendly" :label="$t('no')" :value="false" :round="true" />
          </FieldGroup>
        </div>
      </div>
    </div>
    
    <div class="modal__FiltersBottom buttons">
      <div>
        <button class="button__Text--Underline" @click="skipForNow">{{ $t('skipForNow') }}</button>
      </div>
      <Button class="button--Primary" medium @click="submitData" :disabled="communicationInProgress">{{ $t('submit') }}</Button>
    </div>
  </Modal>
</template>

<script setup>
  const { user: data, getUser } = useAuth('aminess');
  const { t } = useI18n();

  const dialogs = reactive({
    interests: false
  });
  const { open, close } = useModal(dialogs);

  const communicationInProgress = ref(false);
  const preferencesData = ref({
    traveling_with: '',
    hotel: false,
    mobile_homes: false,
    campsite: false,
    family: false,
    sport: false,
    wellness: false,
    gourmet: false,
    romance: false,
    excursions: false,
    pet_friendly: false,
    traveling_alone: false,
    traveling_as_a_couple: false,
    traveling_with_children_0_6: false,
    traveling_with_children_7_14: false,
    traveling_with_pets: false,
  });

  const travelOptions = [
    { title: t('profile.travel.none'), value: 0 },
    { title: t('profile.travel.alone'), value: 1 },
    { title: t('profile.travel.inPair'), value: 2 },
    { title: t('profile.travel.children'), value: 3 },
    { title: t('profile.travel.childrenOlder'), value: 4 },
    { title: t('profile.travel.withPet'), value: 5 },
  ];

  await getInterests();

  function skipForNow() {
    if (import.meta.client) localStorage.setItem('skipInterests', true);
    close('interests');
  }

  async function submitData() {
    if (!data?.value) return;
    try {
      communicationInProgress.value = true;
      let body = JSON.parse(JSON.stringify(preferencesData.value));
      body.traveling_alone = false;
      body.traveling_as_a_couple = false;
      body.traveling_with_children_0_6 = false;
      body.traveling_with_children_7_14 = false;
      body.traveling_with_pets = false;
      switch (body.traveling_with) {
        case '':
          body.traveling_alone = false;
          body.traveling_as_a_couple = false;
          body.traveling_with_children_0_6 = false;
          body.traveling_with_children_7_14 = false;
          body.traveling_with_pets = false;
          break;
        case 1:
          body.traveling_alone = true;
          break;
        case 2:
          body.traveling_as_a_couple = true;
          break;
        case 3:
          body.traveling_with_children_0_6 = true;
          break;
        case 4:
          body.traveling_with_children_7_14 = true;
          break;
        case 5:
          body.traveling_with_pets = true;
          break;
      }
      await useAuthFetch(`loyalty/${data?.value?.loyalty?.card_number}/interests/`, {
        method: 'PUT',
        strategy: 'aminess',
        body: body,
      });
      await getUser();
      await getInterests();
      localStorage.setItem('skipInterests', true);
      close('interests');
    } catch(error) {
      console.log(error)
    }
    communicationInProgress.value = false;
  }

  onMounted(() => {
    if (!localStorage?.getItem('skipInterests') && data?.value) {
      open('interests')
      if (data?.value?.interests) {
        for (let item in data.value.interests) {
          if (preferencesData.value.hasOwnProperty(item)) {
            preferencesData.value[item] = data.value.interests[item];
          }
        }
      }
    }
  });

  async function getInterests() {
    let response = await useAuthFetch(`loyalty/${data?.value?.loyalty?.card_number}/interests/`, {
      method: 'GET',
      strategy: 'aminess',
    });
    let isTravelingWithSet = false;
    for (let item in response) {
      if (preferencesData.value.hasOwnProperty(item)) {
        preferencesData.value[item] = response[item];
        if (item === 'traveling_alone' && response[item]) {
          preferencesData.value.traveling_with = 1;
          isTravelingWithSet = true;
        }
        else if (item === 'traveling_as_a_couple' && response[item]) {
          preferencesData.value.traveling_with = 2;
          isTravelingWithSet = true;
        }
        else if (item === 'traveling_with_children_0_6' && response[item]) {
          preferencesData.value.traveling_with = 3;
          isTravelingWithSet = true;
        }
        else if (item === 'traveling_with_children_7_14' && response[item]) {
          preferencesData.value.traveling_with = 4;
          isTravelingWithSet = true;
        }
        else if (item === 'traveling_with_pets' && response[item]) {
          preferencesData.value.traveling_with = 5;
          isTravelingWithSet = true;
        }
      }
    }
    if (!isTravelingWithSet) {
      preferencesData.value.traveling_with = '';
    }
  }
</script>